export default "__VITE_ASSET__BtshqG3$__"